// ali AMS 监控
if (process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'pre') {
  const BrowserLogger = require('alife-logger')

  window.__bl = BrowserLogger.singleton({
    pid: '9wuupinnea@e57d1ba2af85652',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    enableSPA: true,
    useFmp: true,
    enableConsole: true,
    environment: process.env.VUE_APP_ENV,
    setUsername: function () {
      let userId = 'noauth'
      let userInfo = localStorage.getItem('USER')
        ? JSON.parse(localStorage.getItem('USER'))
        : null
      userId = userInfo && userInfo.userId ? userInfo.userId : userId
      return userId + ''
    },
  })
}
